import { NgModule, Component } from '@angular/core';
import {AuthGuard} from './app.guard';
import { Routes, RouterModule } from '@angular/router';
import {SpeakerdashboardComponent} from '../app/components/speaker/speakerdashboard/speakerdashboard/speakerdashboard.component';
import {LoginComponent} from './components/authentication/login/login.component';
import { PrivacyPolicyComponent } from './components/speaker/privacy-policy/privacy-policy.component';
  const routes: Routes = [
          {
          path:'',
          component:LoginComponent
          },
          {
            path:'dashboard',
            component:SpeakerdashboardComponent
          },
          {
            path:'privacy-policy',
            loadChildren:'./components/speaker/privacy-policy/privacy-policy.module#PrivacyPolicyModule'
          },
         
          // {
          //   path:'forgot-password',
          //   component:ForgotpasswordComponent
          //   },
            {
              path:'forgot-password',
              loadChildren:'./components/authentication/forgotpassword/forgotpassword.module#ForgotpasswordModule'
            },
          // path: 'dashboard',
          // canActivate: [AuthGuard] ,
          // loadChildren: './components/speaker/speakerdashboard/speakerdashboard.module#SpeakerdashboardModule'
          // },
          {
            path: 'resetpassword/:token',
            loadChildren:'./components/authentication/reset-password/reset-password.module#ResetPasswordModule'
          },
          {
            path: 'speaker/dashboard',
            canActivate: [AuthGuard] ,
            loadChildren: './components/speaker/speakerdashboard/speakerdashboard.module#SpeakerdashboardModule'
          },
          {
            path: 'changepassword',
             canActivate: [AuthGuard] ,
             loadChildren:'./components/speaker/cpwd/cpwd.module#CpwdModule'
          },
          {
            path: 'eventdetails/:id',
            canActivate: [AuthGuard] ,
            loadChildren: './components/speaker/eventdetails/eventdetails.module#EventdetailsModule'
          },
          {
            path: 'expenses/:id',
            canActivate: [AuthGuard] ,
            loadChildren: './components/speaker/expenses/expenses.module#ExpensesModule'
          },
          {
          path: 'calendar',
          canActivate: [AuthGuard] ,
          loadChildren: '../app/components/speaker/calendar/calendar.module#CalendarModule'
          },
          {
          path: 'my-story',
          canActivate: [AuthGuard] ,
          loadChildren: '../app/components/speaker/mystory/mystory.module#MystoryModule'
          },
          {
          path:'training',
          canActivate: [AuthGuard] ,
          loadChildren: '../app/components/speaker/training/training.module#TrainingModule'
          },
          {
            path:'trainingdetail/:id',
            canActivate: [AuthGuard] ,
            loadChildren: '../app/components/speaker/trainingdetail/trainingdetail.module#TrainingdetailModule'
            },
            {
              path: 'my-profile',
              canActivate: [AuthGuard] ,
              loadChildren: '../app/components/speaker/myprofile/myprofile.module#MyprofileModule'
              },
  ];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
